import { useMemo, useState } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView, SectionCard } from "@/base";
import {
  downloadAccountDocument,
  type AccountDocumentRow,
} from "@/lib/brokerAccounts";
import { accountDocumentsListView } from "@/pages/accountDocumentsListView";
import { DocumentPreviewDialog } from "@/components/surety-account/DocumentPreviewDialog";

// The Surety account profile's Documents tab (BRK-S139, BRK-S146; a
// BaseListView since BRK-S410), hosted since BRK-S398 on the page's Documents
// tab (SuretyAccountPage.tsx): every document on the account and on its
// submissions, from one aggregated read, each row with Preview and Download.
// Bond history is its own list since BRK-S406 (BondHistoryPanel.tsx).

export function DocumentsPanel({ accountId }: { accountId: string }) {
  const { authedRequest, authedBlob } = useAuth();
  // The row in Preview. The dialog mounts only while one is chosen, so its
  // object URL lives no longer than the dialog does (NN #9).
  const [preview, setPreview] = useState<AccountDocumentRow | null>(null);
  const def = useMemo(
    () =>
      accountDocumentsListView({
        request: authedRequest,
        fetchBlob: authedBlob,
        accountId,
        onPreview: setPreview,
      }),
    [authedRequest, authedBlob, accountId],
  );
  return (
    // In the panel well, as every box on the page is (BRK-S502).
    <SectionCard title="Documents">
      {/* The embedded list draws no header of its own; the wireframe's. */}
      <p className="mb-3 text-sm text-brk-dim">
        Every document added to this account and its submissions. Documents
        Signal generates carry a version number.
      </p>
      <BaseListView def={def} embedded />
      {preview && (
        <DocumentPreviewDialog
          key={preview.id}
          row={preview}
          fetchFile={() =>
            downloadAccountDocument(authedBlob, accountId, preview.id)
          }
          onClose={() => setPreview(null)}
        />
      )}
    </SectionCard>
  );
}
